<template>
    <div class="com-course-catalogue-item" @click="clickItem">
        <div class="com-course-c-i-title">
            <!-- <span class="course-try">试学</span> -->
            <div v-if="curCourseInfo && curCourseInfo.needBuy < 100" class="course-lock"><i class="iconfont icon-lock"></i></div>
            <div class="course-title">{{ itemData.f_title }}</div>
        </div>
        <div class="com-course-c-i-sub-title">
            <p>视频 {{ itemData.timeStr }} | {{ itemData.f_times }}次学习</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CourseCatalogueItem',
    computed: {
        curCourseInfo() {
            return this.$store.state.course.curCourseInfo;
        },
    },
    props: {
        itemData: {
            type: Object,
            default() { return {} }
        }
    },
    data() {
        return {
            locked: false
        }
    },
    methods:{
        clickItem() {
            if(this.locked) { return; }
            this.locked = true;
            setTimeout(() => {
                this.locked = false;
            }, 1000);
            console.log('clickCourseCatalogueItem----', this.curCourseInfo.needBuy)
            if(this.curCourseInfo.needBuy < 100) {
                this.$toast('请先购买课程,再学习课程');
                let curCoursePayInfo = this.$store.state.course.curCoursePayInfo;
                console.log('clickCourseCatalogueItem-----', curCoursePayInfo);
                this.$store.dispatch('pay/createPayOrder', {
                    params: {
                        pid: curCoursePayInfo.pid,
                        ptype: curCoursePayInfo.payType[2],
                        discount: 1
                    },
                    mixParams: {
                        pid: curCoursePayInfo.pid,
                        product_name: curCoursePayInfo.title,
                        price: curCoursePayInfo.price,
                        from: 'course_detail',
                    },
                    sucCb: function() {
                        console.log('支付成功');
                        // 更新课程信息
                        setTimeout(() => {
                            this.$bus.emit('updateCourseDetailFunc');
                        }, 300);
                    },
                    failCb: function() {
                        console.error('支付失败----')
                    }
                });

            }else {
                this.$store.dispatch('course/getCourseDetailInfo', {
                    dId: this.itemData.id,
                    sucCb: () => {
                        this.$router.replace('/course/coursedetail-'+this.itemData.f_cid+'/'+this.itemData.id);
                    }
                });
            }
        }
    }
}
</script>
